import styled from 'styled-components';
import { Button } from '../../Button/Button';

const ActionButtons = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: flex-end;

  .ant-btn-link {
    align-items: center;
    display: flex;
    height: 20px;
    justify-content: center;
    padding: 0;
    width: 20px;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`;

const ConditionalHideWrapper = styled.span`
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
`;

const ContentFull = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;

const FileListPaddingWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 10px 20px 0;

  /* Reserve the scrollbar gutter so the rows don't shift left when the scrollbar appears. The
     header below reserves the same gutter, so AKTIONEN stays aligned with the row action icons. */
  scrollbar-gutter: stable;
`;

const FileListColumnHeaders = styled.div`
  align-items: center;
  border-bottom: 1px solid var(--greyscale-dark-white);
  color: var(--greyscale-shade);
  display: flex;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  justify-content: space-between;
  line-height: var(--font-line-height-regular);

  /* overflow-y:auto + scrollbar-gutter:stable reliably reserves the same gutter as the scrollable
     body below (the header never overflows vertically, so no scrollbar shows). overflow-x:hidden
     keeps the row clipped. Right padding (40px) matches the action icons' inset in the rows
     (body padding 20 + card 10 + buttons 10) so AKTIONEN lines up with the last icon. */
  overflow: hidden auto;
  padding: 10px 40px 10px 20px;
  scrollbar-gutter: stable;

  > span:last-child {
    font-weight: normal;
  }

  svg {
    height: 14px;
    width: 14px;

    path {
      stroke: var(--primary-oqio-blue);
    }
  }
`;

const HiddenButton = styled(Button)`
  visibility: hidden;
`;

const IchBadge = styled.span.attrs({ className: 'ich-badge' })`
  background: var(--greyscale-dark-white);
  border-radius: var(--border-radius-extra-large);
  color: var(--greyscale-blackish);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-small);
  margin-left: 8px;
  padding: 2px 10px;
`;

const NameCell = styled.span`
  align-items: center;
  display: inline-flex;
  max-width: 100%;
  overflow: hidden;
`;

const RiskCountBubble = styled.span.attrs({ className: 'count-pill' })`
  align-items: flex-start;
  background: var(--greyscale-dark-white);
  border-radius: 10px;
  color: var(--greyscale-blackish);
  display: inline-flex;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  gap: 10px;
  line-height: 16px;
  padding: 2px 10px;
  white-space: nowrap;
`;

const SortableColumnHeader = styled.span`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  gap: 4px;
  user-select: none;

  svg path {
    stroke: var(--primary-oqio-blue);
  }
`;

const TableDescription = styled.p`
  color: var(--greyscale-shade);
  font-size: var(--font-size-regular);
  line-height: var(--font-line-height-regular);
  margin: 0;
  max-width: 540px;
`;

const TableDescriptionRow = styled.div`
  align-items: flex-start;
  border-bottom: 1px solid var(--greyscale-dark-white);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
`;

const TableHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  padding: 20px;
`;

const TableScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

const TitleRow = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const TableEmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 60px 20px;
  width: 100%;
`;

const TableLoadingWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;

const TableLayout = {
  ActionButtons,
  ConditionalHideWrapper,
  ContentFull,
  FileListColumnHeaders,
  FileListPaddingWrapper,
  HiddenButton,
  IchBadge,
  NameCell,
  RiskCountBubble,
  SortableColumnHeader,
  TableDescription,
  TableDescriptionRow,
  TableEmptyStateWrapper,
  TableHeader,
  TableLoadingWrapper,
  TableScrollArea,
  TitleRow
};

export default TableLayout;
